import { IDateRangeFilterValue } from './date-range-filter.interface';

export interface IApiDateRange {
  fromDate: string;
  toDate: string;
}

// Normalizes the selected range to the full day span before sending to the API -
// fromDate at 00:00:00.000 and toDate at 23:59:59.999 - so a same-day filter
// (e.g. "Today", where fromDate/toDate hold the exact moment of selection) still
// returns the whole day's results instead of just that instant.
export function toApiDateRange(
  dateFilter: Pick<IDateRangeFilterValue, 'fromDate' | 'toDate'>
): IApiDateRange {
  const fromDate = new Date(dateFilter.fromDate);
  fromDate.setHours(0, 0, 0, 0);

  const toDate = new Date(dateFilter.toDate);
  toDate.setHours(23, 59, 59, 999);

  return { fromDate: fromDate.toISOString(), toDate: toDate.toISOString() };
}

export default toApiDateRange;
